import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/Auth/auth-context';
import { isHostRole } from '../../types/authcontext.types';

export const Navbar = () => {
  const { user, userInfo } = useAuth();
  const { pathname } = useLocation();
  if (!user || !isHostRole(userInfo?.role)) return null;

  const link = (to: string, label: string) => (
    <Link
      to={to}
      className={`px-3 py-1.5 rounded-lg text-sm font-semibold transition ${
        pathname === to ? 'bg-ink text-white' : 'text-ink/70 hover:bg-ink/10'
      }`}
    >
      {label}
    </Link>
  );

  return (
    <nav className="flex items-center gap-1 ml-2">
      {link('/admin/create', 'Create Quiz')}
      {link('/admin/quizzes', 'Quizzes')}
      {/* Crews: presenter groups that share quizzes. My Page: the public
          presenter brand page editor (players see it at /p/:uid). */}
      {link('/admin/crews', 'Crews')}
      {link('/admin/profile', 'My Page')}
      {/* Presenter onboarding is admin-only (rules enforce it too). */}
      {userInfo?.role === 'admin' && link('/admin/presenters', 'Presenters')}
      {/* Bots is a dev/seeding tool, not a presenting control — kept off this
          always-visible menu so it can never appear on a shared screen. The UI
          entry is the avatar dropdown in Layout (deliberate click); direct URLs
          /admin/bots and /admin/session/:code/bots also work. */}
    </nav>
  );
};
